<template>
  <v-dialog fullscreen  v-model="dialog" max-width="1500">
    <v-card>
      <v-card-title class="border-bottom">
        Kapatılmamış Faturalar - {{ this.currentProp ? this.currentProp.code + ' ' + this.currentProp.name : '' }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="py-3 d-flex">
          <div>
            <PrintPage></PrintPage>
            <ExcelExport
              :dataProp="currentUnclosedInvoiceList"
              :columnProp="currentUnclosedInvoiceListHeaders"
              :fileNameProp="this.currentProp ? 'Cari Stok Hareketleri ' + this.currentProp.code + ' ' + this.currentProp.name : ''"
            >

            </ExcelExport>

          </div>

          <div class="ms-auto">
            <v-text-field
                v-model="searchText"
                class="mt-5 pt-3"
                outlined
                rounded
                dense
                placeholder="Arama Yapın..."
                clearable
                hide-details
                append-icon="mdi-magnify"
                @click:append="searchListWithText()"
                @keydown.enter="searchListWithText()"
            >

            </v-text-field>
          </div>
        </div>
        <div >
          <b-table
              :items="currentUnclosedInvoiceList"
              :fields="currentUnclosedInvoiceListHeaders"
              hover
              small
              responsive
              sort-icon-left
              :busy="currentUnclosedInvoiceListLoading"
              id="sectionToPrint"
              head-row-variant="info"
              table-variant="white"
              show-empty
          >
            <template #empty="scope">
              <h6 class="text-center my-5">
                {{ scope.loading ? "Lütfen Bekleyin" : noCurrentMessage ? noCurrentMessage : "Veri Bulunamadı" }}
              </h6>
            </template>
            <template #cell(invoiceDate)="data">
              {{ formattedDate(data.item.invoiceDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(expiryDate)="data">
              {{ formattedDate(data.item.expiryDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(invoiceAmount)="data">
              {{ numberConverter(data.item.invoiceAmount) }}
            </template>
            <template #cell(unclosedAmount)="data">
              {{ numberConverter(data.item.unclosedAmount) }}
            </template>
            <template #cell(remainingAmount)="data">
              {{ numberConverter(data.item.remainingAmount) }}
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Lütfen Bekleyin..."
                ></b-spinner>
              </div>
            </template>
          </b-table>
          <!--
          <div class="row">
            <div class="col-lg-12 mb-5">
              <v-pagination
                  v-model="currentPage"
                  circle
                  class="my-4"
                  :length="currentListMetaData.totalPages"
                  :total-visible="10"
              ></v-pagination>
            </div>
          </div>
          -->

        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex';
import {formattedDate} from "@/momentHelper";
import {numberConverter, printView} from "../../../../helpers";
import ExcelExport from "@/components/shared/ExcelExport";
import PrintPage from "@/components/shared/PrintPage";

export default {
  name: "CurrentUnclosedInvoicesDialog",
  components:{
    ExcelExport,
    PrintPage
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentProp: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("current", ["currentUnclosedInvoiceList", "currentUnclosedInvoiceListHeaders", "currentUnclosedInvoiceListLoading","noCurrentMessage"])
  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      searchText: "",
    };
  },
  methods: {
    numberConverter,
    ...mapActions("current", ["fetchCurrentUnclosedInvoiceList"]),
    ...mapMutations("current", ["setCurrentUnclosedInvoiceList"]),
    printView,
    formattedDate,
    closeDialog() {
      this.dialog = false;
      this.searchText = null;
    },
    searchListWithText() {
      this.fetchCurrentUnclosedInvoiceList({
        params: {


        },
        body: {
          currentCode: this.currentProp.code,
          ...(!(this.searchText === "" || this.searchText === null)) && {documentNumber: this.searchText}
          // ...(!(this.searchText === "" || this.searchText === null)) && {SearchText: this.searchText}
        }
      });
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal)
        this.fetchCurrentUnclosedInvoiceList({
          params: {


          },
          body: {
            currentCode: this.currentProp.code,
            ...(!(this.searchText === "" || this.searchText === null)) && {documentNumber: this.searchText}
          }
        });
      else
        this.setCurrentUnclosedInvoiceList([])

    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    }
  }
}
</script>

<style scoped>

</style>